

























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { IValoresServicos, PercentualServicoDTO} from "@/models/commons/ConfiguracaoModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class ListaPrestadores extends Vue {
  valores: PercentualServicoDTO[] = [];
  loading = false;
  cabecalho = [
      { text: "Descrição", value: "descricao", width: "60%" },
      { text: "Valor", value: "valor", width: "20%" },
      { text: "Ações", value: "actions", width: "15%", sortable: false }
  ];
  salvarPercentual: PercentualServicoDTO = {
    id: "",
    valor: "",
    descricao: ""
  };
  valorServico: IValoresServicos = { 
    id:"", 
    valor:"", 
    descricao: ""
  };
  dialogType = "sucess";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  isEdit = false;
  valid = true;
  alterarConfiguracao(valoresServicos: IValoresServicos) {
    this.isEdit = true;
    this.valorServico = Object.assign({}, valoresServicos);
  }

  beforeMount() {
    this.obterConfiguracao();
  }

  obterConfiguracao() {
    this.loading = true;
    this.valores = [];
    ServicosAssistenciaService
    .obterConfiguracao(
      ).then((res: PercentualServicoDTO[]) => {
          this.valores = res;
          this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  salvarConfiguracao() {
    this.valid = true;
    if(this.valorServico.id == "QTD_EIXOS_PRECIFICACAO") {
      if(Number(this.valorServico.valor) < 1 || Number(this.valorServico.valor) > 8) {
        this.valid = false;
        this.openDialog('error', 'Dados inválidos.', 'Quantidade de eixos deve ser entre 1 e 8.');
      }  
    }
    if (this.valid) {
      this.salvarPercentual.id = this.valorServico.id;
      this.salvarPercentual.valor = this.valorServico.valor;
      this.salvarPercentual.descricao = this.valorServico.descricao;
      ServicosAssistenciaService
      .salvarConfiguracao(
        this.salvarPercentual
      ).then((res: PercentualServicoDTO) => {
        this.resetConfiguracao();
        this.openDialog('success', "Alteração realizada com sucesso", "Alteração realizada com sucesso");
      })
      .catch((err) => {
          console.log(err);
          this.openDialog('error', 'Erro ao realizar alteração.', 'Ocorreu um erro ao tentar gravar os dados.');
        });
    }    
  }

  resetConfiguracao() {
    this.valorServico.id = "";
    this.valorServico.valor = "";
    this.valorServico.descricao = "";
    this.isEdit = false;
    this.valid = true;
    this.obterConfiguracao();
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "warning";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }
}
